import dateService from "@/services/date.service";

export default {
    getLastModifiedBy(object) {
        if (object && object.lastModifiedBy) {
            return object.lastModifiedBy.firstName + ' ' + object.lastModifiedBy.lastName;
        }
        return '';
    },

    getLastModifiedDate(object) {
        if (object.lastModifiedDate) {
            return dateService.formatDateTime(object.lastModifiedDate);
        }
        return '';
    }
}